<div class="ui-modal">
    <div class="header flex-row space-between-center">
        {{data?.name}}
        <span class="ui-icon-close c-p"
              mat-dialog-close>
        </span>
    </div>
    <div class="body">
        <div class="flex-row container">
            <div class="modal-tab node-tab w-100">
                <div class="content">
                    @if(selectIsNodeLoadingSig()) {
                    <ui-preloader [color]="loaderColor.blue"
                                  style="min-height: 256px;">
                    </ui-preloader>
                    } @else {
                    @switch (data?.type) {
                    @case (workflowNodeTypes.Webhook) {
                    <edit-webhook [selectedNodeForEdit]="data"
                                  [markSelectAsTouched]="data?.data?.shouldMarkFormAsTouched ?? false"
                                  [disableForm]="data?.data?.disableForm ?? false">
                    </edit-webhook>
                    }
                    @case (workflowNodeTypes.WaitWebhook) {
                    <edit-wait-webhook [selectedNodeForEdit]="data"
                                       [disableForm]="data?.data?.disableForm ?? false"
                                       [markSelectAsTouched]="data?.data?.shouldMarkFormAsTouched ?? false">
                    </edit-wait-webhook>
                    }
                    @case (workflowNodeTypes.HttpRequest) {
                    <edit-http-request [selectedNodeForEdit]="data"
                                       [disableForm]="data?.data?.disableForm ?? false"
                                       [markSelectAsTouched]="data?.data?.shouldMarkFormAsTouched ?? false">
                    </edit-http-request>
                    }
                    @case (workflowNodeTypes.Condition) {
                    <edit-condition [disableForm]="data?.data?.disableForm ?? false"
                                    [selectedNodeForEdit]="data">
                    </edit-condition>
                    }
                    @case(workflowNodeTypes.AlertTrigger) {
                    <edit-alerts [selectedNodeForEdit]="data"
                                 [disableForm]="data?.data?.disableForm ?? false">
                    </edit-alerts>
                    }
                    @case(workflowNodeTypes.WaitAlert) {
                    <edit-wait-alert [selectedNodeForEdit]="data"
                                     [disableForm]="data?.data?.disableForm ?? false">
                    </edit-wait-alert>
                    }
                    @case(workflowNodeTypes.Echo) {
                    <edit-echo [selectedNodeForEdit]="data"
                               [disableForm]="data?.data?.disableForm ?? false">
                    </edit-echo>
                    }
                    @case (workflowNodeTypes.SendSms) {
                    <edit-send-sms [disableForm]="data?.data?.disableForm ?? false"
                                   [selectedNodeForEdit]="data">
                    </edit-send-sms>
                    }
                    @case (workflowNodeTypes.SendEmail) {
                    <edit-send-email [disableForm]="data?.data?.disableForm ?? false"
                                     [selectedNodeForEdit]="data">
                    </edit-send-email>
                    }
                    @case (workflowNodeTypes.WaitSms) {
                    <edit-wait-sms [disableForm]="data?.data?.disableForm ?? false"
                                   [selectedNodeForEdit]="data">
                    </edit-wait-sms>
                    }
                    @case (workflowNodeTypes.WaitEmail) {
                    <edit-wait-email [disableForm]="data?.data?.disableForm ?? false"
                                     [selectedNodeForEdit]="data">
                    </edit-wait-email>
                    }
                    @case (workflowNodeTypes.Wait) {
                    <edit-wait [disableForm]="data?.data?.disableForm ?? false"
                               [selectedNodeForEdit]="data">
                    </edit-wait>
                    }
                    @case (workflowNodeTypes.MobilePush) {
                    <edit-mobile-push [disableForm]="data?.data?.disableForm ?? false"
                                      [selectedNodeForEdit]="data"
                                      [markSelectAsTouched]="data?.data?.shouldMarkFormAsTouched ?? false">
                    </edit-mobile-push>
                    }
                    @case (workflowNodeTypes.WaitMobilePush) {
                    <edit-wait-mobile-push [disableForm]="data?.data?.disableForm ?? false"
                                           [selectedNodeForEdit]="data">
                    </edit-wait-mobile-push>
                    }
                    @case (workflowNodeTypes.Video) {
                    <edit-video [disableForm]="data?.data?.disableForm ?? false"
                                [selectedNodeForEdit]="data">
                    </edit-video>
                    }
                    @case (workflowNodeTypes.SetFps) {
                    <edit-set-fps [disableForm]="data?.data?.disableForm ?? false"
                                  [selectedNodeForEdit]="data">
                    </edit-set-fps>
                    }
                    @case (workflowNodeTypes.Trim) {
                    <edit-trim [disableForm]="data?.data?.disableForm ?? false"
                               [selectedNodeForEdit]="data">
                    </edit-trim>
                    }
                    @case (workflowNodeTypes.Crop) {
                    <edit-crop [disableForm]="data?.data?.disableForm ?? false"
                               [selectedNodeForEdit]="data">
                    </edit-crop>
                    }
                    @case (workflowNodeTypes.Resize) {
                    <edit-resize [disableForm]="data?.data?.disableForm ?? false"
                                 [selectedNodeForEdit]="data">
                    </edit-resize>
                    }
                    @case (workflowNodeTypes.GetImage) {
                    <edit-get-image [disableForm]="data?.data?.disableForm ?? false"
                                    [selectedNodeForEdit]="data">
                    </edit-get-image>
                    }
                    @case (workflowNodeTypes.AI) {
                    <edit-ai [disableForm]="data?.data?.disableForm ?? false"
                             [selectedNodeForEdit]="data">
                    </edit-ai>
                    }
                    @case (workflowNodeTypes.ManualTrigger) {
                    <edit-trigger-manually [disableForm]="data?.data?.disableForm ?? false"
                                           [selectedNodeForEdit]="data">
                    </edit-trigger-manually>
                    }
                    @case (workflowNodeTypes.ScheduleTrigger) {
                    <edit-schedule-trigger [disableForm]="data?.data?.disableForm ?? false"
                                           [selectedNodeForEdit]="data">
                    </edit-schedule-trigger>
                    }
                    @case (workflowNodeTypes.JsCode) {
                    <edit-js-code [disableForm]="data?.data?.disableForm ?? false"
                                  [selectedNodeForEdit]="data">
                    </edit-js-code>
                    }
                    }
                    }
                </div>
            </div>
        </div>
    </div>

    <div class="footer flex-row end-center">
        <ui-button type="default"
                   [text]="'COMMON.CANCEL'|translate"
                   (clickAction)="close()">
        </ui-button>

        <ui-button type="primary"
                   [text]="'COMMON.SAVE'|translate"
                   [disabled]="data?.data?.disableForm || ((!selectIsNodeLoadingSig() && activeEditTabSig()?.form) ? activeEditTabSig().form.invalid : false)"
                   (clickAction)="save()">
        </ui-button>
    </div>
</div>